import { observer } from "mobx-react";
import { useRootStore } from "../stores/RootStoreContext";
import { useEffect } from "react";
import { LoadingIndicator } from "../components-v2/LoadingIndicator";
import { toQueryString, useQuery } from "../utils/queryParams";

const SigningCompletedBankIdCallbackPage = observer(function SigningCompletedBankIdCallbackPage() {
  const { userStore } = useRootStore();
  const companyName = useQuery().get("signing-complete-company");
  const history = useRootStore().history;
  useEffect(() => {
    const moduleName = userStore.hasOnlyShareholderAccess ? "companies" : "follow-up/signatures";
    const url = `/portfolio/all/${moduleName}/${toQueryString({ "signing-complete": true, "signing-complete-company": companyName })}`;
    history.replace(url);
  }, [userStore.hasOnlyShareholderAccess, history, companyName]);
  return <LoadingIndicator />;
});

export default SigningCompletedBankIdCallbackPage;
